import { defineComponent as Qt, h as at, ref as he, onMounted as xt, nextTick as Ar, watch as st, unref as Dr, reactive as Sr, getCurrentInstance as Mr, onUnmounted as Rr, isRef as Ee, isReactive as Lt, isVNode as Lr, render as Bt } from "vue";
/*!
  * vue-tippy v6.0.0-alpha.63
  * (c) 2022 
  * @license MIT
  */
var N = "top", Y = "bottom", q = "right", F = "left", Ct = "auto", We = [N, Y, q, F], Pe = "start", Ve = "end", Br = "clippingParents", Zt = "viewport", je = "popper", Ir = "reference", It = /* @__PURE__ */ We.reduce(function(e, t) {
  return e.concat([t + "-" + Pe, t + "-" + Ve]);
}, []), er = /* @__PURE__ */ [].concat(We, [Ct]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Pe, t + "-" + Ve]);
}, []), kr = "beforeRead", $r = "read", jr = "afterRead", Hr = "beforeMain", Ur = "main", Vr = "afterMain", Nr = "beforeWrite", Fr = "write", Wr = "afterWrite", Xr = [kr, $r, jr, Hr, Ur, Vr, Nr, Fr, Wr];
function re(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function K(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Ae(e) {
  var t = K(e).Element;
  return e instanceof t || e instanceof Element;
}
function X(e) {
  var t = K(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function tr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = K(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Yr(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var i = t.styles[r] || {}, o = t.attributes[r] || {}, a = t.elements[r];
    !X(a) || !re(a) || (Object.assign(a.style, i), Object.keys(o).forEach(function(s) {
      var u = o[s];
      u === !1 ? a.removeAttribute(s) : a.setAttribute(s, u === !0 ? "" : u);
    }));
  });
}
function qr(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(i) {
      var o = t.elements[i], a = t.attributes[i] || {}, s = Object.keys(t.styles.hasOwnProperty(i) ? t.styles[i] : r[i]), u = s.reduce(function(p, d) {
        return p[d] = "", p;
      }, {});
      !X(o) || !re(o) || (Object.assign(o.style, u), Object.keys(a).forEach(function(p) {
        o.removeAttribute(p);
      }));
    });
  };
}
var rr = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Yr,
  effect: qr,
  requires: ["computeStyles"]
};
function te(e) {
  return e.split("-")[0];
}
var ye = Math.max, ut = Math.min, De = Math.round;
function Se(e, t) {
  t === void 0 && (t = !1);
  var r = e.getBoundingClientRect(), i = 1, o = 1;
  if (X(e) && t) {
    var a = e.offsetHeight, s = e.offsetWidth;
    s > 0 && (i = De(r.width) / s || 1), a > 0 && (o = De(r.height) / a || 1);
  }
  return {
    width: r.width / i,
    height: r.height / o,
    top: r.top / o,
    right: r.right / i,
    bottom: r.bottom / o,
    left: r.left / i,
    x: r.left / i,
    y: r.top / o
  };
}
function Tt(e) {
  var t = Se(e), r = e.offsetWidth, i = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - i) <= 1 && (i = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: i
  };
}
function nr(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && tr(r)) {
    var i = t;
    do {
      if (i && e.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function ne(e) {
  return K(e).getComputedStyle(e);
}
function zr(e) {
  return ["table", "td", "th"].indexOf(re(e)) >= 0;
}
function le(e) {
  return ((Ae(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function lt(e) {
  return re(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (tr(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    le(e)
  );
}
function kt(e) {
  return !X(e) || // https://github.com/popperjs/popper-core/issues/837
  ne(e).position === "fixed" ? null : e.offsetParent;
}
function _r(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, r = navigator.userAgent.indexOf("Trident") !== -1;
  if (r && X(e)) {
    var i = ne(e);
    if (i.position === "fixed")
      return null;
  }
  for (var o = lt(e); X(o) && ["html", "body"].indexOf(re(o)) < 0; ) {
    var a = ne(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Xe(e) {
  for (var t = K(e), r = kt(e); r && zr(r) && ne(r).position === "static"; )
    r = kt(r);
  return r && (re(r) === "html" || re(r) === "body" && ne(r).position === "static") ? t : r || _r(e) || t;
}
function Et(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function He(e, t, r) {
  return ye(e, ut(t, r));
}
function Gr(e, t, r) {
  var i = He(e, t, r);
  return i > r ? r : i;
}
function ir() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function or(e) {
  return Object.assign({}, ir(), e);
}
function ar(e, t) {
  return t.reduce(function(r, i) {
    return r[i] = e, r;
  }, {});
}
var Kr = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, or(typeof t != "number" ? t : ar(t, We));
};
function Jr(e) {
  var t, r = e.state, i = e.name, o = e.options, a = r.elements.arrow, s = r.modifiersData.popperOffsets, u = te(r.placement), p = Et(u), d = [F, q].indexOf(u) >= 0, c = d ? "height" : "width";
  if (!(!a || !s)) {
    var O = Kr(o.padding, r), E = Tt(a), x = p === "y" ? N : F, g = p === "y" ? Y : q, h = r.rects.reference[c] + r.rects.reference[p] - s[p] - r.rects.popper[c], C = s[p] - r.rects.reference[p], m = Xe(a), T = m ? p === "y" ? m.clientHeight || 0 : m.clientWidth || 0 : 0, D = h / 2 - C / 2, n = O[x], y = T - E[c] - O[g], f = T / 2 - E[c] / 2 + D, v = He(n, f, y), A = p;
    r.modifiersData[i] = (t = {}, t[A] = v, t.centerOffset = v - f, t);
  }
}
function Qr(e) {
  var t = e.state, r = e.options, i = r.element, o = i === void 0 ? "[data-popper-arrow]" : i;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || nr(t.elements.popper, o) && (t.elements.arrow = o));
}
var Zr = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Jr,
  effect: Qr,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Me(e) {
  return e.split("-")[1];
}
var en = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function tn(e) {
  var t = e.x, r = e.y, i = window, o = i.devicePixelRatio || 1;
  return {
    x: De(t * o) / o || 0,
    y: De(r * o) / o || 0
  };
}
function $t(e) {
  var t, r = e.popper, i = e.popperRect, o = e.placement, a = e.variation, s = e.offsets, u = e.position, p = e.gpuAcceleration, d = e.adaptive, c = e.roundOffsets, O = e.isFixed, E = c === !0 ? tn(s) : typeof c == "function" ? c(s) : s, x = E.x, g = x === void 0 ? 0 : x, h = E.y, C = h === void 0 ? 0 : h, m = s.hasOwnProperty("x"), T = s.hasOwnProperty("y"), D = F, n = N, y = window;
  if (d) {
    var f = Xe(r), v = "clientHeight", A = "clientWidth";
    if (f === K(r) && (f = le(r), ne(f).position !== "static" && u === "absolute" && (v = "scrollHeight", A = "scrollWidth")), f = f, o === N || (o === F || o === q) && a === Ve) {
      n = Y;
      var R = O && y.visualViewport ? y.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        f[v]
      );
      C -= R - i.height, C *= p ? 1 : -1;
    }
    if (o === F || (o === N || o === Y) && a === Ve) {
      D = q;
      var B = O && y.visualViewport ? y.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        f[A]
      );
      g -= B - i.width, g *= p ? 1 : -1;
    }
  }
  var I = Object.assign({
    position: u
  }, d && en);
  if (p) {
    var L;
    return Object.assign({}, I, (L = {}, L[n] = T ? "0" : "", L[D] = m ? "0" : "", L.transform = (y.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + C + "px)" : "translate3d(" + g + "px, " + C + "px, 0)", L));
  }
  return Object.assign({}, I, (t = {}, t[n] = T ? C + "px" : "", t[D] = m ? g + "px" : "", t.transform = "", t));
}
function rn(e) {
  var t = e.state, r = e.options, i = r.gpuAcceleration, o = i === void 0 ? !0 : i, a = r.adaptive, s = a === void 0 ? !0 : a, u = r.roundOffsets, p = u === void 0 ? !0 : u, d = {
    placement: te(t.placement),
    variation: Me(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, $t(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: p
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, $t(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: p
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
var nn = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: rn,
  data: {}
}, rt = {
  passive: !0
};
function on(e) {
  var t = e.state, r = e.instance, i = e.options, o = i.scroll, a = o === void 0 ? !0 : o, s = i.resize, u = s === void 0 ? !0 : s, p = K(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && d.forEach(function(c) {
    c.addEventListener("scroll", r.update, rt);
  }), u && p.addEventListener("resize", r.update, rt), function() {
    a && d.forEach(function(c) {
      c.removeEventListener("scroll", r.update, rt);
    }), u && p.removeEventListener("resize", r.update, rt);
  };
}
var an = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: on,
  data: {}
}, sn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ot(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return sn[t];
  });
}
var un = {
  start: "end",
  end: "start"
};
function jt(e) {
  return e.replace(/start|end/g, function(t) {
    return un[t];
  });
}
function Pt(e) {
  var t = K(e), r = t.pageXOffset, i = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: i
  };
}
function At(e) {
  return Se(le(e)).left + Pt(e).scrollLeft;
}
function fn(e) {
  var t = K(e), r = le(e), i = t.visualViewport, o = r.clientWidth, a = r.clientHeight, s = 0, u = 0;
  return i && (o = i.width, a = i.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (s = i.offsetLeft, u = i.offsetTop)), {
    width: o,
    height: a,
    x: s + At(e),
    y: u
  };
}
function ln(e) {
  var t, r = le(e), i = Pt(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = ye(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = ye(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), u = -i.scrollLeft + At(e), p = -i.scrollTop;
  return ne(o || r).direction === "rtl" && (u += ye(r.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: s,
    x: u,
    y: p
  };
}
function Dt(e) {
  var t = ne(e), r = t.overflow, i = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + i);
}
function sr(e) {
  return ["html", "body", "#document"].indexOf(re(e)) >= 0 ? e.ownerDocument.body : X(e) && Dt(e) ? e : sr(lt(e));
}
function Ue(e, t) {
  var r;
  t === void 0 && (t = []);
  var i = sr(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = K(i), s = o ? [a].concat(a.visualViewport || [], Dt(i) ? i : []) : i, u = t.concat(s);
  return o ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(Ue(lt(s)))
  );
}
function yt(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function pn(e) {
  var t = Se(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Ht(e, t) {
  return t === Zt ? yt(fn(e)) : Ae(t) ? pn(t) : yt(ln(le(e)));
}
function cn(e) {
  var t = Ue(lt(e)), r = ["absolute", "fixed"].indexOf(ne(e).position) >= 0, i = r && X(e) ? Xe(e) : e;
  return Ae(i) ? t.filter(function(o) {
    return Ae(o) && nr(o, i) && re(o) !== "body" && (r ? ne(o).position !== "static" : !0);
  }) : [];
}
function dn(e, t, r) {
  var i = t === "clippingParents" ? cn(e) : [].concat(t), o = [].concat(i, [r]), a = o[0], s = o.reduce(function(u, p) {
    var d = Ht(e, p);
    return u.top = ye(d.top, u.top), u.right = ut(d.right, u.right), u.bottom = ut(d.bottom, u.bottom), u.left = ye(d.left, u.left), u;
  }, Ht(e, a));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function ur(e) {
  var t = e.reference, r = e.element, i = e.placement, o = i ? te(i) : null, a = i ? Me(i) : null, s = t.x + t.width / 2 - r.width / 2, u = t.y + t.height / 2 - r.height / 2, p;
  switch (o) {
    case N:
      p = {
        x: s,
        y: t.y - r.height
      };
      break;
    case Y:
      p = {
        x: s,
        y: t.y + t.height
      };
      break;
    case q:
      p = {
        x: t.x + t.width,
        y: u
      };
      break;
    case F:
      p = {
        x: t.x - r.width,
        y: u
      };
      break;
    default:
      p = {
        x: t.x,
        y: t.y
      };
  }
  var d = o ? Et(o) : null;
  if (d != null) {
    var c = d === "y" ? "height" : "width";
    switch (a) {
      case Pe:
        p[d] = p[d] - (t[c] / 2 - r[c] / 2);
        break;
      case Ve:
        p[d] = p[d] + (t[c] / 2 - r[c] / 2);
        break;
    }
  }
  return p;
}
function Ne(e, t) {
  t === void 0 && (t = {});
  var r = t, i = r.placement, o = i === void 0 ? e.placement : i, a = r.boundary, s = a === void 0 ? Br : a, u = r.rootBoundary, p = u === void 0 ? Zt : u, d = r.elementContext, c = d === void 0 ? je : d, O = r.altBoundary, E = O === void 0 ? !1 : O, x = r.padding, g = x === void 0 ? 0 : x, h = or(typeof g != "number" ? g : ar(g, We)), C = c === je ? Ir : je, m = e.rects.popper, T = e.elements[E ? C : c], D = dn(Ae(T) ? T : T.contextElement || le(e.elements.popper), s, p), n = Se(e.elements.reference), y = ur({
    reference: n,
    element: m,
    placement: o
  }), f = yt(Object.assign({}, m, y)), v = c === je ? f : n, A = {
    top: D.top - v.top + h.top,
    bottom: v.bottom - D.bottom + h.bottom,
    left: D.left - v.left + h.left,
    right: v.right - D.right + h.right
  }, R = e.modifiersData.offset;
  if (c === je && R) {
    var B = R[o];
    Object.keys(A).forEach(function(I) {
      var L = [q, Y].indexOf(I) >= 0 ? 1 : -1, k = [N, Y].indexOf(I) >= 0 ? "y" : "x";
      A[I] += B[k] * L;
    });
  }
  return A;
}
function vn(e, t) {
  t === void 0 && (t = {});
  var r = t, i = r.placement, o = r.boundary, a = r.rootBoundary, s = r.padding, u = r.flipVariations, p = r.allowedAutoPlacements, d = p === void 0 ? er : p, c = Me(i), O = c ? u ? It : It.filter(function(g) {
    return Me(g) === c;
  }) : We, E = O.filter(function(g) {
    return d.indexOf(g) >= 0;
  });
  E.length === 0 && (E = O);
  var x = E.reduce(function(g, h) {
    return g[h] = Ne(e, {
      placement: h,
      boundary: o,
      rootBoundary: a,
      padding: s
    })[te(h)], g;
  }, {});
  return Object.keys(x).sort(function(g, h) {
    return x[g] - x[h];
  });
}
function mn(e) {
  if (te(e) === Ct)
    return [];
  var t = ot(e);
  return [jt(e), t, jt(t)];
}
function gn(e) {
  var t = e.state, r = e.options, i = e.name;
  if (!t.modifiersData[i]._skip) {
    for (var o = r.mainAxis, a = o === void 0 ? !0 : o, s = r.altAxis, u = s === void 0 ? !0 : s, p = r.fallbackPlacements, d = r.padding, c = r.boundary, O = r.rootBoundary, E = r.altBoundary, x = r.flipVariations, g = x === void 0 ? !0 : x, h = r.allowedAutoPlacements, C = t.options.placement, m = te(C), T = m === C, D = p || (T || !g ? [ot(C)] : mn(C)), n = [C].concat(D).reduce(function(ie, _) {
      return ie.concat(te(_) === Ct ? vn(t, {
        placement: _,
        boundary: c,
        rootBoundary: O,
        padding: d,
        flipVariations: g,
        allowedAutoPlacements: h
      }) : _);
    }, []), y = t.rects.reference, f = t.rects.popper, v = /* @__PURE__ */ new Map(), A = !0, R = n[0], B = 0; B < n.length; B++) {
      var I = n[B], L = te(I), k = Me(I) === Pe, V = [N, Y].indexOf(L) >= 0, z = V ? "width" : "height", j = Ne(t, {
        placement: I,
        boundary: c,
        rootBoundary: O,
        altBoundary: E,
        padding: d
      }), H = V ? k ? q : F : k ? Y : N;
      y[z] > f[z] && (H = ot(H));
      var $ = ot(H), J = [];
      if (a && J.push(j[L] <= 0), u && J.push(j[H] <= 0, j[$] <= 0), J.every(function(ie) {
        return ie;
      })) {
        R = I, A = !1;
        break;
      }
      v.set(I, J);
    }
    if (A)
      for (var Q = g ? 3 : 1, pe = function(_) {
        var oe = n.find(function(we) {
          var ae = v.get(we);
          if (ae)
            return ae.slice(0, _).every(function(Oe) {
              return Oe;
            });
        });
        if (oe)
          return R = oe, "break";
      }, Z = Q; Z > 0; Z--) {
        var ce = pe(Z);
        if (ce === "break") break;
      }
    t.placement !== R && (t.modifiersData[i]._skip = !0, t.placement = R, t.reset = !0);
  }
}
var hn = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: gn,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ut(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Vt(e) {
  return [N, q, Y, F].some(function(t) {
    return e[t] >= 0;
  });
}
function yn(e) {
  var t = e.state, r = e.name, i = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, s = Ne(t, {
    elementContext: "reference"
  }), u = Ne(t, {
    altBoundary: !0
  }), p = Ut(s, i), d = Ut(u, o, a), c = Vt(p), O = Vt(d);
  t.modifiersData[r] = {
    referenceClippingOffsets: p,
    popperEscapeOffsets: d,
    isReferenceHidden: c,
    hasPopperEscaped: O
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": O
  });
}
var bn = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: yn
};
function wn(e, t, r) {
  var i = te(e), o = [F, N].indexOf(i) >= 0 ? -1 : 1, a = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, s = a[0], u = a[1];
  return s = s || 0, u = (u || 0) * o, [F, q].indexOf(i) >= 0 ? {
    x: u,
    y: s
  } : {
    x: s,
    y: u
  };
}
function On(e) {
  var t = e.state, r = e.options, i = e.name, o = r.offset, a = o === void 0 ? [0, 0] : o, s = er.reduce(function(c, O) {
    return c[O] = wn(O, t.rects, a), c;
  }, {}), u = s[t.placement], p = u.x, d = u.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += p, t.modifiersData.popperOffsets.y += d), t.modifiersData[i] = s;
}
var xn = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: On
};
function Cn(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = ur({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
var Tn = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Cn,
  data: {}
};
function En(e) {
  return e === "x" ? "y" : "x";
}
function Pn(e) {
  var t = e.state, r = e.options, i = e.name, o = r.mainAxis, a = o === void 0 ? !0 : o, s = r.altAxis, u = s === void 0 ? !1 : s, p = r.boundary, d = r.rootBoundary, c = r.altBoundary, O = r.padding, E = r.tether, x = E === void 0 ? !0 : E, g = r.tetherOffset, h = g === void 0 ? 0 : g, C = Ne(t, {
    boundary: p,
    rootBoundary: d,
    padding: O,
    altBoundary: c
  }), m = te(t.placement), T = Me(t.placement), D = !T, n = Et(m), y = En(n), f = t.modifiersData.popperOffsets, v = t.rects.reference, A = t.rects.popper, R = typeof h == "function" ? h(Object.assign({}, t.rects, {
    placement: t.placement
  })) : h, B = typeof R == "number" ? {
    mainAxis: R,
    altAxis: R
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, R), I = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (f) {
    if (a) {
      var k, V = n === "y" ? N : F, z = n === "y" ? Y : q, j = n === "y" ? "height" : "width", H = f[n], $ = H + C[V], J = H - C[z], Q = x ? -A[j] / 2 : 0, pe = T === Pe ? v[j] : A[j], Z = T === Pe ? -A[j] : -v[j], ce = t.elements.arrow, ie = x && ce ? Tt(ce) : {
        width: 0,
        height: 0
      }, _ = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : ir(), oe = _[V], we = _[z], ae = He(0, v[j], ie[j]), Oe = D ? v[j] / 2 - Q - ae - oe - B.mainAxis : pe - ae - oe - B.mainAxis, ue = D ? -v[j] / 2 + Q + ae + we + B.mainAxis : Z + ae + we + B.mainAxis, xe = t.elements.arrow && Xe(t.elements.arrow), Ye = xe ? n === "y" ? xe.clientTop || 0 : xe.clientLeft || 0 : 0, Le = (k = I == null ? void 0 : I[n]) != null ? k : 0, qe = H + Oe - Le - Ye, ze = H + ue - Le, Be = He(x ? ut($, qe) : $, H, x ? ye(J, ze) : J);
      f[n] = Be, L[n] = Be - H;
    }
    if (u) {
      var Ie, _e = n === "x" ? N : F, Ge = n === "x" ? Y : q, se = f[y], fe = y === "y" ? "height" : "width", ke = se + C[_e], de = se - C[Ge], $e = [N, F].indexOf(m) !== -1, Ke = (Ie = I == null ? void 0 : I[y]) != null ? Ie : 0, Je = $e ? ke : se - v[fe] - A[fe] - Ke + B.altAxis, Qe = $e ? se + v[fe] + A[fe] - Ke - B.altAxis : de, Ze = x && $e ? Gr(Je, se, Qe) : He(x ? Je : ke, se, x ? Qe : de);
      f[y] = Ze, L[y] = Ze - se;
    }
    t.modifiersData[i] = L;
  }
}
var An = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Pn,
  requiresIfExists: ["offset"]
};
function Dn(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Sn(e) {
  return e === K(e) || !X(e) ? Pt(e) : Dn(e);
}
function Mn(e) {
  var t = e.getBoundingClientRect(), r = De(t.width) / e.offsetWidth || 1, i = De(t.height) / e.offsetHeight || 1;
  return r !== 1 || i !== 1;
}
function Rn(e, t, r) {
  r === void 0 && (r = !1);
  var i = X(t), o = X(t) && Mn(t), a = le(t), s = Se(e, o), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, p = {
    x: 0,
    y: 0
  };
  return (i || !i && !r) && ((re(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Dt(a)) && (u = Sn(t)), X(t) ? (p = Se(t, !0), p.x += t.clientLeft, p.y += t.clientTop) : a && (p.x = At(a))), {
    x: s.left + u.scrollLeft - p.x,
    y: s.top + u.scrollTop - p.y,
    width: s.width,
    height: s.height
  };
}
function Ln(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), i = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    r.add(a.name);
    var s = [].concat(a.requires || [], a.requiresIfExists || []);
    s.forEach(function(u) {
      if (!r.has(u)) {
        var p = t.get(u);
        p && o(p);
      }
    }), i.push(a);
  }
  return e.forEach(function(a) {
    r.has(a.name) || o(a);
  }), i;
}
function Bn(e) {
  var t = Ln(e);
  return Xr.reduce(function(r, i) {
    return r.concat(t.filter(function(o) {
      return o.phase === i;
    }));
  }, []);
}
function In(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function kn(e) {
  var t = e.reduce(function(r, i) {
    var o = r[i.name];
    return r[i.name] = o ? Object.assign({}, o, i, {
      options: Object.assign({}, o.options, i.options),
      data: Object.assign({}, o.data, i.data)
    }) : i, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Nt = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ft() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function $n(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, i = r === void 0 ? [] : r, o = t.defaultOptions, a = o === void 0 ? Nt : o;
  return function(u, p, d) {
    d === void 0 && (d = a);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Nt, a),
      modifiersData: {},
      elements: {
        reference: u,
        popper: p
      },
      attributes: {},
      styles: {}
    }, O = [], E = !1, x = {
      state: c,
      setOptions: function(m) {
        var T = typeof m == "function" ? m(c.options) : m;
        h(), c.options = Object.assign({}, a, c.options, T), c.scrollParents = {
          reference: Ae(u) ? Ue(u) : u.contextElement ? Ue(u.contextElement) : [],
          popper: Ue(p)
        };
        var D = Bn(kn([].concat(i, c.options.modifiers)));
        return c.orderedModifiers = D.filter(function(n) {
          return n.enabled;
        }), g(), x.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!E) {
          var m = c.elements, T = m.reference, D = m.popper;
          if (Ft(T, D)) {
            c.rects = {
              reference: Rn(T, Xe(D), c.options.strategy === "fixed"),
              popper: Tt(D)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(B) {
              return c.modifiersData[B.name] = Object.assign({}, B.data);
            });
            for (var n = 0; n < c.orderedModifiers.length; n++) {
              if (c.reset === !0) {
                c.reset = !1, n = -1;
                continue;
              }
              var y = c.orderedModifiers[n], f = y.fn, v = y.options, A = v === void 0 ? {} : v, R = y.name;
              typeof f == "function" && (c = f({
                state: c,
                options: A,
                name: R,
                instance: x
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: In(function() {
        return new Promise(function(C) {
          x.forceUpdate(), C(c);
        });
      }),
      destroy: function() {
        h(), E = !0;
      }
    };
    if (!Ft(u, p))
      return x;
    x.setOptions(d).then(function(C) {
      !E && d.onFirstUpdate && d.onFirstUpdate(C);
    });
    function g() {
      c.orderedModifiers.forEach(function(C) {
        var m = C.name, T = C.options, D = T === void 0 ? {} : T, n = C.effect;
        if (typeof n == "function") {
          var y = n({
            state: c,
            name: m,
            instance: x,
            options: D
          }), f = function() {
          };
          O.push(y || f);
        }
      });
    }
    function h() {
      O.forEach(function(C) {
        return C();
      }), O = [];
    }
    return x;
  };
}
var jn = [an, Tn, nn, rr, xn, hn, An, Zr, bn], Hn = /* @__PURE__ */ $n({
  defaultModifiers: jn
}), Un = "tippy-box", fr = "tippy-content", lr = "tippy-backdrop", pr = "tippy-arrow", cr = "tippy-svg-arrow", me = {
  passive: !0,
  capture: !0
}, dr = function() {
  return document.body;
};
function vt(e, t, r) {
  if (Array.isArray(e)) {
    var i = e[t];
    return i ?? (Array.isArray(r) ? r[t] : r);
  }
  return e;
}
function St(e, t) {
  var r = {}.toString.call(e);
  return r.indexOf("[object") === 0 && r.indexOf(t + "]") > -1;
}
function vr(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function Wt(e, t) {
  if (t === 0)
    return e;
  var r;
  return function(i) {
    clearTimeout(r), r = setTimeout(function() {
      e(i);
    }, t);
  };
}
function Vn(e, t) {
  var r = Object.assign({}, e);
  return t.forEach(function(i) {
    delete r[i];
  }), r;
}
function Nn(e) {
  return e.split(/\s+/).filter(Boolean);
}
function ge(e) {
  return [].concat(e);
}
function Xt(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Fn(e) {
  return e.filter(function(t, r) {
    return e.indexOf(t) === r;
  });
}
function mr(e) {
  return e.split("-")[0];
}
function Re(e) {
  return [].slice.call(e);
}
function Yt(e) {
  return Object.keys(e).reduce(function(t, r) {
    return e[r] !== void 0 && (t[r] = e[r]), t;
  }, {});
}
function be() {
  return document.createElement("div");
}
function pt(e) {
  return ["Element", "Fragment"].some(function(t) {
    return St(e, t);
  });
}
function Wn(e) {
  return St(e, "NodeList");
}
function Mt(e) {
  return St(e, "MouseEvent");
}
function Xn(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function Yn(e) {
  return pt(e) ? [e] : Wn(e) ? Re(e) : Array.isArray(e) ? e : Re(document.querySelectorAll(e));
}
function mt(e, t) {
  e.forEach(function(r) {
    r && (r.style.transitionDuration = t + "ms");
  });
}
function Fe(e, t) {
  e.forEach(function(r) {
    r && r.setAttribute("data-state", t);
  });
}
function gr(e) {
  var t, r = ge(e), i = r[0];
  return i != null && (t = i.ownerDocument) != null && t.body ? i.ownerDocument : document;
}
function qn(e, t) {
  var r = t.clientX, i = t.clientY;
  return e.every(function(o) {
    var a = o.popperRect, s = o.popperState, u = o.props, p = u.interactiveBorder, d = mr(s.placement), c = s.modifiersData.offset;
    if (!c)
      return !0;
    var O = d === "bottom" ? c.top.y : 0, E = d === "top" ? c.bottom.y : 0, x = d === "right" ? c.left.x : 0, g = d === "left" ? c.right.x : 0, h = a.top - i + O > p, C = i - a.bottom - E > p, m = a.left - r + x > p, T = r - a.right - g > p;
    return h || C || m || T;
  });
}
function gt(e, t, r) {
  var i = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    e[i](o, r);
  });
}
function qt(e, t) {
  for (var r = t; r; ) {
    var i;
    if (e.contains(r))
      return !0;
    r = r.getRootNode == null || (i = r.getRootNode()) == null ? void 0 : i.host;
  }
  return !1;
}
var ee = {
  isTouch: !1
}, zt = 0;
function zn() {
  ee.isTouch || (ee.isTouch = !0, window.performance && document.addEventListener("mousemove", hr));
}
function hr() {
  var e = performance.now();
  e - zt < 20 && (ee.isTouch = !1, document.removeEventListener("mousemove", hr)), zt = e;
}
function _n() {
  var e = document.activeElement;
  if (Xn(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function Gn() {
  document.addEventListener("touchstart", zn, me), window.addEventListener("blur", _n);
}
var Kn = typeof window < "u" && typeof document < "u", Jn = Kn ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, Qn = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Zn = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, G = Object.assign({
  appendTo: dr,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Qn, Zn), ei = Object.keys(G), ti = function(t) {
  var r = Object.keys(t);
  r.forEach(function(i) {
    G[i] = t[i];
  });
};
function yr(e) {
  var t = e.plugins || [], r = t.reduce(function(i, o) {
    var a = o.name, s = o.defaultValue;
    if (a) {
      var u;
      i[a] = e[a] !== void 0 ? e[a] : (u = G[a]) != null ? u : s;
    }
    return i;
  }, {});
  return Object.assign({}, e, r);
}
function ri(e, t) {
  var r = t ? Object.keys(yr(Object.assign({}, G, {
    plugins: t
  }))) : ei, i = r.reduce(function(o, a) {
    var s = (e.getAttribute("data-tippy-" + a) || "").trim();
    if (!s)
      return o;
    if (a === "content")
      o[a] = s;
    else
      try {
        o[a] = JSON.parse(s);
      } catch {
        o[a] = s;
      }
    return o;
  }, {});
  return i;
}
function _t(e, t) {
  var r = Object.assign({}, t, {
    content: vr(t.content, [e])
  }, t.ignoreAttributes ? {} : ri(e, t.plugins));
  return r.aria = Object.assign({}, G.aria, r.aria), r.aria = {
    expanded: r.aria.expanded === "auto" ? t.interactive : r.aria.expanded,
    content: r.aria.content === "auto" ? t.interactive ? null : "describedby" : r.aria.content
  }, r;
}
var ni = function() {
  return "innerHTML";
};
function bt(e, t) {
  e[ni()] = t;
}
function Gt(e) {
  var t = be();
  return e === !0 ? t.className = pr : (t.className = cr, pt(e) ? t.appendChild(e) : bt(t, e)), t;
}
function Kt(e, t) {
  pt(t.content) ? (bt(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? bt(e, t.content) : e.textContent = t.content);
}
function ft(e) {
  var t = e.firstElementChild, r = Re(t.children);
  return {
    box: t,
    content: r.find(function(i) {
      return i.classList.contains(fr);
    }),
    arrow: r.find(function(i) {
      return i.classList.contains(pr) || i.classList.contains(cr);
    }),
    backdrop: r.find(function(i) {
      return i.classList.contains(lr);
    })
  };
}
function br(e) {
  var t = be(), r = be();
  r.className = Un, r.setAttribute("data-state", "hidden"), r.setAttribute("tabindex", "-1");
  var i = be();
  i.className = fr, i.setAttribute("data-state", "hidden"), Kt(i, e.props), t.appendChild(r), r.appendChild(i), o(e.props, e.props);
  function o(a, s) {
    var u = ft(t), p = u.box, d = u.content, c = u.arrow;
    s.theme ? p.setAttribute("data-theme", s.theme) : p.removeAttribute("data-theme"), typeof s.animation == "string" ? p.setAttribute("data-animation", s.animation) : p.removeAttribute("data-animation"), s.inertia ? p.setAttribute("data-inertia", "") : p.removeAttribute("data-inertia"), p.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? p.setAttribute("role", s.role) : p.removeAttribute("role"), (a.content !== s.content || a.allowHTML !== s.allowHTML) && Kt(d, e.props), s.arrow ? c ? a.arrow !== s.arrow && (p.removeChild(c), p.appendChild(Gt(s.arrow))) : p.appendChild(Gt(s.arrow)) : c && p.removeChild(c);
  }
  return {
    popper: t,
    onUpdate: o
  };
}
br.$$tippy = !0;
var ii = 1, nt = [], ht = [];
function oi(e, t) {
  var r = _t(e, Object.assign({}, G, yr(Yt(t)))), i, o, a, s = !1, u = !1, p = !1, d = !1, c, O, E, x = [], g = Wt(qe, r.interactiveDebounce), h, C = ii++, m = null, T = Fn(r.plugins), D = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, n = {
    // properties
    id: C,
    reference: e,
    popper: be(),
    popperInstance: m,
    props: r,
    state: D,
    plugins: T,
    // methods
    clearDelayTimeouts: Je,
    setProps: Qe,
    setContent: Ze,
    show: Or,
    hide: xr,
    hideWithInteractivity: Cr,
    enable: $e,
    disable: Ke,
    unmount: Tr,
    destroy: Er
  };
  if (!r.render)
    return n;
  var y = r.render(n), f = y.popper, v = y.onUpdate;
  f.setAttribute("data-tippy-root", ""), f.id = "tippy-" + n.id, n.popper = f, e._tippy = n, f._tippy = n;
  var A = T.map(function(l) {
    return l.fn(n);
  }), R = e.hasAttribute("aria-expanded");
  return xe(), Q(), H(), $("onCreate", [n]), r.showOnCreate && ke(), f.addEventListener("mouseenter", function() {
    n.props.interactive && n.state.isVisible && n.clearDelayTimeouts();
  }), f.addEventListener("mouseleave", function() {
    n.props.interactive && n.props.trigger.indexOf("mouseenter") >= 0 && V().addEventListener("mousemove", g);
  }), n;
  function B() {
    var l = n.props.touch;
    return Array.isArray(l) ? l : [l, 0];
  }
  function I() {
    return B()[0] === "hold";
  }
  function L() {
    var l;
    return !!((l = n.props.render) != null && l.$$tippy);
  }
  function k() {
    return h || e;
  }
  function V() {
    var l = k().parentNode;
    return l ? gr(l) : document;
  }
  function z() {
    return ft(f);
  }
  function j(l) {
    return n.state.isMounted && !n.state.isVisible || ee.isTouch || c && c.type === "focus" ? 0 : vt(n.props.delay, l ? 0 : 1, G.delay);
  }
  function H(l) {
    l === void 0 && (l = !1), f.style.pointerEvents = n.props.interactive && !l ? "" : "none", f.style.zIndex = "" + n.props.zIndex;
  }
  function $(l, b, P) {
    if (P === void 0 && (P = !0), A.forEach(function(S) {
      S[l] && S[l].apply(S, b);
    }), P) {
      var M;
      (M = n.props)[l].apply(M, b);
    }
  }
  function J() {
    var l = n.props.aria;
    if (l.content) {
      var b = "aria-" + l.content, P = f.id, M = ge(n.props.triggerTarget || e);
      M.forEach(function(S) {
        var U = S.getAttribute(b);
        if (n.state.isVisible)
          S.setAttribute(b, U ? U + " " + P : P);
        else {
          var W = U && U.replace(P, "").trim();
          W ? S.setAttribute(b, W) : S.removeAttribute(b);
        }
      });
    }
  }
  function Q() {
    if (!(R || !n.props.aria.expanded)) {
      var l = ge(n.props.triggerTarget || e);
      l.forEach(function(b) {
        n.props.interactive ? b.setAttribute("aria-expanded", n.state.isVisible && b === k() ? "true" : "false") : b.removeAttribute("aria-expanded");
      });
    }
  }
  function pe() {
    V().removeEventListener("mousemove", g), nt = nt.filter(function(l) {
      return l !== g;
    });
  }
  function Z(l) {
    if (!(ee.isTouch && (p || l.type === "mousedown"))) {
      var b = l.composedPath && l.composedPath()[0] || l.target;
      if (!(n.props.interactive && qt(f, b))) {
        if (ge(n.props.triggerTarget || e).some(function(P) {
          return qt(P, b);
        })) {
          if (ee.isTouch || n.state.isVisible && n.props.trigger.indexOf("click") >= 0)
            return;
        } else
          $("onClickOutside", [n, l]);
        n.props.hideOnClick === !0 && (n.clearDelayTimeouts(), n.hide(), u = !0, setTimeout(function() {
          u = !1;
        }), n.state.isMounted || oe());
      }
    }
  }
  function ce() {
    p = !0;
  }
  function ie() {
    p = !1;
  }
  function _() {
    var l = V();
    l.addEventListener("mousedown", Z, !0), l.addEventListener("touchend", Z, me), l.addEventListener("touchstart", ie, me), l.addEventListener("touchmove", ce, me);
  }
  function oe() {
    var l = V();
    l.removeEventListener("mousedown", Z, !0), l.removeEventListener("touchend", Z, me), l.removeEventListener("touchstart", ie, me), l.removeEventListener("touchmove", ce, me);
  }
  function we(l, b) {
    Oe(l, function() {
      !n.state.isVisible && f.parentNode && f.parentNode.contains(f) && b();
    });
  }
  function ae(l, b) {
    Oe(l, b);
  }
  function Oe(l, b) {
    var P = z().box;
    function M(S) {
      S.target === P && (gt(P, "remove", M), b());
    }
    if (l === 0)
      return b();
    gt(P, "remove", O), gt(P, "add", M), O = M;
  }
  function ue(l, b, P) {
    P === void 0 && (P = !1);
    var M = ge(n.props.triggerTarget || e);
    M.forEach(function(S) {
      S.addEventListener(l, b, P), x.push({
        node: S,
        eventType: l,
        handler: b,
        options: P
      });
    });
  }
  function xe() {
    I() && (ue("touchstart", Le, {
      passive: !0
    }), ue("touchend", ze, {
      passive: !0
    })), Nn(n.props.trigger).forEach(function(l) {
      if (l !== "manual")
        switch (ue(l, Le), l) {
          case "mouseenter":
            ue("mouseleave", ze);
            break;
          case "focus":
            ue(Jn ? "focusout" : "blur", Be);
            break;
          case "focusin":
            ue("focusout", Be);
            break;
        }
    });
  }
  function Ye() {
    x.forEach(function(l) {
      var b = l.node, P = l.eventType, M = l.handler, S = l.options;
      b.removeEventListener(P, M, S);
    }), x = [];
  }
  function Le(l) {
    var b, P = !1;
    if (!(!n.state.isEnabled || Ie(l) || u)) {
      var M = ((b = c) == null ? void 0 : b.type) === "focus";
      c = l, h = l.currentTarget, Q(), !n.state.isVisible && Mt(l) && nt.forEach(function(S) {
        return S(l);
      }), l.type === "click" && (n.props.trigger.indexOf("mouseenter") < 0 || s) && n.props.hideOnClick !== !1 && n.state.isVisible ? P = !0 : ke(l), l.type === "click" && (s = !P), P && !M && de(l);
    }
  }
  function qe(l) {
    var b = l.target, P = k().contains(b) || f.contains(b);
    if (!(l.type === "mousemove" && P)) {
      var M = fe().concat(f).map(function(S) {
        var U, W = S._tippy, Ce = (U = W.popperInstance) == null ? void 0 : U.state;
        return Ce ? {
          popperRect: S.getBoundingClientRect(),
          popperState: Ce,
          props: r
        } : null;
      }).filter(Boolean);
      qn(M, l) && (pe(), de(l));
    }
  }
  function ze(l) {
    var b = Ie(l) || n.props.trigger.indexOf("click") >= 0 && s;
    if (!b) {
      if (n.props.interactive) {
        n.hideWithInteractivity(l);
        return;
      }
      de(l);
    }
  }
  function Be(l) {
    n.props.trigger.indexOf("focusin") < 0 && l.target !== k() || n.props.interactive && l.relatedTarget && f.contains(l.relatedTarget) || de(l);
  }
  function Ie(l) {
    return ee.isTouch ? I() !== l.type.indexOf("touch") >= 0 : !1;
  }
  function _e() {
    Ge();
    var l = n.props, b = l.popperOptions, P = l.placement, M = l.offset, S = l.getReferenceClientRect, U = l.moveTransition, W = L() ? ft(f).arrow : null, Ce = S ? {
      getBoundingClientRect: S,
      contextElement: S.contextElement || k()
    } : e, Rt = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(et) {
        var Te = et.state;
        if (L()) {
          var Pr = z(), dt = Pr.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(tt) {
            tt === "placement" ? dt.setAttribute("data-placement", Te.placement) : Te.attributes.popper["data-popper-" + tt] ? dt.setAttribute("data-" + tt, "") : dt.removeAttribute("data-" + tt);
          }), Te.attributes.popper = {};
        }
      }
    }, ve = [{
      name: "offset",
      options: {
        offset: M
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !U
      }
    }, Rt];
    L() && W && ve.push({
      name: "arrow",
      options: {
        element: W,
        padding: 3
      }
    }), ve.push.apply(ve, (b == null ? void 0 : b.modifiers) || []), n.popperInstance = Hn(Ce, f, Object.assign({}, b, {
      placement: P,
      onFirstUpdate: E,
      modifiers: ve
    }));
  }
  function Ge() {
    n.popperInstance && (n.popperInstance.destroy(), n.popperInstance = null);
  }
  function se() {
    var l = n.props.appendTo, b, P = k();
    n.props.interactive && l === dr || l === "parent" ? b = P.parentNode : b = vr(l, [P]), b.contains(f) || b.appendChild(f), n.state.isMounted = !0, _e();
  }
  function fe() {
    return Re(f.querySelectorAll("[data-tippy-root]"));
  }
  function ke(l) {
    n.clearDelayTimeouts(), l && $("onTrigger", [n, l]), _();
    var b = j(!0), P = B(), M = P[0], S = P[1];
    ee.isTouch && M === "hold" && S && (b = S), b ? i = setTimeout(function() {
      n.show();
    }, b) : n.show();
  }
  function de(l) {
    if (n.clearDelayTimeouts(), $("onUntrigger", [n, l]), !n.state.isVisible) {
      oe();
      return;
    }
    if (!(n.props.trigger.indexOf("mouseenter") >= 0 && n.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(l.type) >= 0 && s)) {
      var b = j(!1);
      b ? o = setTimeout(function() {
        n.state.isVisible && n.hide();
      }, b) : a = requestAnimationFrame(function() {
        n.hide();
      });
    }
  }
  function $e() {
    n.state.isEnabled = !0;
  }
  function Ke() {
    n.hide(), n.state.isEnabled = !1;
  }
  function Je() {
    clearTimeout(i), clearTimeout(o), cancelAnimationFrame(a);
  }
  function Qe(l) {
    if (!n.state.isDestroyed) {
      $("onBeforeUpdate", [n, l]), Ye();
      var b = n.props, P = _t(e, Object.assign({}, b, Yt(l), {
        ignoreAttributes: !0
      }));
      n.props = P, xe(), b.interactiveDebounce !== P.interactiveDebounce && (pe(), g = Wt(qe, P.interactiveDebounce)), b.triggerTarget && !P.triggerTarget ? ge(b.triggerTarget).forEach(function(M) {
        M.removeAttribute("aria-expanded");
      }) : P.triggerTarget && e.removeAttribute("aria-expanded"), Q(), H(), v && v(b, P), n.popperInstance && (_e(), fe().forEach(function(M) {
        requestAnimationFrame(M._tippy.popperInstance.forceUpdate);
      })), $("onAfterUpdate", [n, l]);
    }
  }
  function Ze(l) {
    n.setProps({
      content: l
    });
  }
  function Or() {
    var l = n.state.isVisible, b = n.state.isDestroyed, P = !n.state.isEnabled, M = ee.isTouch && !n.props.touch, S = vt(n.props.duration, 0, G.duration);
    if (!(l || b || P || M) && !k().hasAttribute("disabled") && ($("onShow", [n], !1), n.props.onShow(n) !== !1)) {
      if (n.state.isVisible = !0, L() && (f.style.visibility = "visible"), H(), _(), n.state.isMounted || (f.style.transition = "none"), L()) {
        var U = z(), W = U.box, Ce = U.content;
        mt([W, Ce], 0);
      }
      E = function() {
        var ve;
        if (!(!n.state.isVisible || d)) {
          if (d = !0, f.offsetHeight, f.style.transition = n.props.moveTransition, L() && n.props.animation) {
            var ct = z(), et = ct.box, Te = ct.content;
            mt([et, Te], S), Fe([et, Te], "visible");
          }
          J(), Q(), Xt(ht, n), (ve = n.popperInstance) == null || ve.forceUpdate(), $("onMount", [n]), n.props.animation && L() && ae(S, function() {
            n.state.isShown = !0, $("onShown", [n]);
          });
        }
      }, se();
    }
  }
  function xr() {
    var l = !n.state.isVisible, b = n.state.isDestroyed, P = !n.state.isEnabled, M = vt(n.props.duration, 1, G.duration);
    if (!(l || b || P) && ($("onHide", [n], !1), n.props.onHide(n) !== !1)) {
      if (n.state.isVisible = !1, n.state.isShown = !1, d = !1, s = !1, L() && (f.style.visibility = "hidden"), pe(), oe(), H(!0), L()) {
        var S = z(), U = S.box, W = S.content;
        n.props.animation && (mt([U, W], M), Fe([U, W], "hidden"));
      }
      J(), Q(), n.props.animation ? L() && we(M, n.unmount) : n.unmount();
    }
  }
  function Cr(l) {
    V().addEventListener("mousemove", g), Xt(nt, g), g(l);
  }
  function Tr() {
    n.state.isVisible && n.hide(), n.state.isMounted && (Ge(), fe().forEach(function(l) {
      l._tippy.unmount();
    }), f.parentNode && f.parentNode.removeChild(f), ht = ht.filter(function(l) {
      return l !== n;
    }), n.state.isMounted = !1, $("onHidden", [n]));
  }
  function Er() {
    n.state.isDestroyed || (n.clearDelayTimeouts(), n.unmount(), Ye(), delete e._tippy, n.state.isDestroyed = !0, $("onDestroy", [n]));
  }
}
function w(e, t) {
  t === void 0 && (t = {});
  var r = G.plugins.concat(t.plugins || []);
  Gn();
  var i = Object.assign({}, t, {
    plugins: r
  }), o = Yn(e), a = o.reduce(function(s, u) {
    var p = u && oi(u, i);
    return p && s.push(p), s;
  }, []);
  return pt(e) ? a[0] : a;
}
w.defaultProps = G;
w.setDefaultProps = ti;
w.currentInput = ee;
var ai = Object.assign({}, rr, {
  effect: function(t) {
    var r = t.state, i = {
      popper: {
        position: r.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(r.elements.popper.style, i.popper), r.styles = i, r.elements.arrow && Object.assign(r.elements.arrow.style, i.arrow);
  }
}), si = function(t, r) {
  var i;
  r === void 0 && (r = {});
  var o = t, a = [], s = [], u, p = r.overrides, d = [], c = !1;
  function O() {
    s = o.map(function(n) {
      return ge(n.props.triggerTarget || n.reference);
    }).reduce(function(n, y) {
      return n.concat(y);
    }, []);
  }
  function E() {
    a = o.map(function(n) {
      return n.reference;
    });
  }
  function x(n) {
    o.forEach(function(y) {
      n ? y.enable() : y.disable();
    });
  }
  function g(n) {
    return o.map(function(y) {
      var f = y.setProps;
      return y.setProps = function(v) {
        f(v), y.reference === u && n.setProps(v);
      }, function() {
        y.setProps = f;
      };
    });
  }
  function h(n, y) {
    var f = s.indexOf(y);
    if (y !== u) {
      u = y;
      var v = (p || []).concat("content").reduce(function(A, R) {
        return A[R] = o[f].props[R], A;
      }, {});
      n.setProps(Object.assign({}, v, {
        getReferenceClientRect: typeof v.getReferenceClientRect == "function" ? v.getReferenceClientRect : function() {
          var A;
          return (A = a[f]) == null ? void 0 : A.getBoundingClientRect();
        }
      }));
    }
  }
  x(!1), E(), O();
  var C = {
    fn: function() {
      return {
        onDestroy: function() {
          x(!0);
        },
        onHidden: function() {
          u = null;
        },
        onClickOutside: function(f) {
          f.props.showOnCreate && !c && (c = !0, u = null);
        },
        onShow: function(f) {
          f.props.showOnCreate && !c && (c = !0, h(f, a[0]));
        },
        onTrigger: function(f, v) {
          h(f, v.currentTarget);
        }
      };
    }
  }, m = w(be(), Object.assign({}, Vn(r, ["overrides"]), {
    plugins: [C].concat(r.plugins || []),
    triggerTarget: s,
    popperOptions: Object.assign({}, r.popperOptions, {
      modifiers: [].concat(((i = r.popperOptions) == null ? void 0 : i.modifiers) || [], [ai])
    })
  })), T = m.show;
  m.show = function(n) {
    if (T(), !u && n == null)
      return h(m, a[0]);
    if (!(u && n == null)) {
      if (typeof n == "number")
        return a[n] && h(m, a[n]);
      if (o.indexOf(n) >= 0) {
        var y = n.reference;
        return h(m, y);
      }
      if (a.indexOf(n) >= 0)
        return h(m, n);
    }
  }, m.showNext = function() {
    var n = a[0];
    if (!u)
      return m.show(0);
    var y = a.indexOf(u);
    m.show(a[y + 1] || n);
  }, m.showPrevious = function() {
    var n = a[a.length - 1];
    if (!u)
      return m.show(n);
    var y = a.indexOf(u), f = a[y - 1] || n;
    m.show(f);
  };
  var D = m.setProps;
  return m.setProps = function(n) {
    p = n.overrides || p, D(n);
  }, m.setInstances = function(n) {
    x(!0), d.forEach(function(y) {
      return y();
    }), o = n, x(!1), E(), O(), d = g(m), m.setProps({
      triggerTarget: s
    });
  }, d = g(m), m;
}, ui = {
  name: "animateFill",
  defaultValue: !1,
  fn: function(t) {
    var r;
    if (!((r = t.props.render) != null && r.$$tippy))
      return {};
    var i = ft(t.popper), o = i.box, a = i.content, s = t.props.animateFill ? fi() : null;
    return {
      onCreate: function() {
        s && (o.insertBefore(s, o.firstElementChild), o.setAttribute("data-animatefill", ""), o.style.overflow = "hidden", t.setProps({
          arrow: !1,
          animation: "shift-away"
        }));
      },
      onMount: function() {
        if (s) {
          var p = o.style.transitionDuration, d = Number(p.replace("ms", ""));
          a.style.transitionDelay = Math.round(d / 10) + "ms", s.style.transitionDuration = p, Fe([s], "visible");
        }
      },
      onShow: function() {
        s && (s.style.transitionDuration = "0ms");
      },
      onHide: function() {
        s && Fe([s], "hidden");
      }
    };
  }
};
function fi() {
  var e = be();
  return e.className = lr, Fe([e], "hidden"), e;
}
var wt = {
  clientX: 0,
  clientY: 0
}, it = [];
function wr(e) {
  var t = e.clientX, r = e.clientY;
  wt = {
    clientX: t,
    clientY: r
  };
}
function li(e) {
  e.addEventListener("mousemove", wr);
}
function pi(e) {
  e.removeEventListener("mousemove", wr);
}
var ci = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(t) {
    var r = t.reference, i = gr(t.props.triggerTarget || r), o = !1, a = !1, s = !0, u = t.props;
    function p() {
      return t.props.followCursor === "initial" && t.state.isVisible;
    }
    function d() {
      i.addEventListener("mousemove", E);
    }
    function c() {
      i.removeEventListener("mousemove", E);
    }
    function O() {
      o = !0, t.setProps({
        getReferenceClientRect: null
      }), o = !1;
    }
    function E(h) {
      var C = h.target ? r.contains(h.target) : !0, m = t.props.followCursor, T = h.clientX, D = h.clientY, n = r.getBoundingClientRect(), y = T - n.left, f = D - n.top;
      (C || !t.props.interactive) && t.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var A = r.getBoundingClientRect(), R = T, B = D;
          m === "initial" && (R = A.left + y, B = A.top + f);
          var I = m === "horizontal" ? A.top : B, L = m === "vertical" ? A.right : R, k = m === "horizontal" ? A.bottom : B, V = m === "vertical" ? A.left : R;
          return {
            width: L - V,
            height: k - I,
            top: I,
            right: L,
            bottom: k,
            left: V
          };
        }
      });
    }
    function x() {
      t.props.followCursor && (it.push({
        instance: t,
        doc: i
      }), li(i));
    }
    function g() {
      it = it.filter(function(h) {
        return h.instance !== t;
      }), it.filter(function(h) {
        return h.doc === i;
      }).length === 0 && pi(i);
    }
    return {
      onCreate: x,
      onDestroy: g,
      onBeforeUpdate: function() {
        u = t.props;
      },
      onAfterUpdate: function(C, m) {
        var T = m.followCursor;
        o || T !== void 0 && u.followCursor !== T && (g(), T ? (x(), t.state.isMounted && !a && !p() && d()) : (c(), O()));
      },
      onMount: function() {
        t.props.followCursor && !a && (s && (E(wt), s = !1), p() || d());
      },
      onTrigger: function(C, m) {
        Mt(m) && (wt = {
          clientX: m.clientX,
          clientY: m.clientY
        }), a = m.type === "focus";
      },
      onHidden: function() {
        t.props.followCursor && (O(), c(), s = !0);
      }
    };
  }
};
function di(e, t) {
  var r;
  return {
    popperOptions: Object.assign({}, e.popperOptions, {
      modifiers: [].concat((((r = e.popperOptions) == null ? void 0 : r.modifiers) || []).filter(function(i) {
        var o = i.name;
        return o !== t.name;
      }), [t])
    })
  };
}
var vi = {
  name: "inlinePositioning",
  defaultValue: !1,
  fn: function(t) {
    var r = t.reference;
    function i() {
      return !!t.props.inlinePositioning;
    }
    var o, a = -1, s = !1, u = [], p = {
      name: "tippyInlinePositioning",
      enabled: !0,
      phase: "afterWrite",
      fn: function(x) {
        var g = x.state;
        i() && (u.indexOf(g.placement) !== -1 && (u = []), o !== g.placement && u.indexOf(g.placement) === -1 && (u.push(g.placement), t.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function() {
            return d(g.placement);
          }
        })), o = g.placement);
      }
    };
    function d(E) {
      return mi(mr(E), r.getBoundingClientRect(), Re(r.getClientRects()), a);
    }
    function c(E) {
      s = !0, t.setProps(E), s = !1;
    }
    function O() {
      s || c(di(t.props, p));
    }
    return {
      onCreate: O,
      onAfterUpdate: O,
      onTrigger: function(x, g) {
        if (Mt(g)) {
          var h = Re(t.reference.getClientRects()), C = h.find(function(T) {
            return T.left - 2 <= g.clientX && T.right + 2 >= g.clientX && T.top - 2 <= g.clientY && T.bottom + 2 >= g.clientY;
          }), m = h.indexOf(C);
          a = m > -1 ? m : a;
        }
      },
      onHidden: function() {
        a = -1;
      }
    };
  }
};
function mi(e, t, r, i) {
  if (r.length < 2 || e === null)
    return t;
  if (r.length === 2 && i >= 0 && r[0].left > r[1].right)
    return r[i] || t;
  switch (e) {
    case "top":
    case "bottom": {
      var o = r[0], a = r[r.length - 1], s = e === "top", u = o.top, p = a.bottom, d = s ? o.left : a.left, c = s ? o.right : a.right, O = c - d, E = p - u;
      return {
        top: u,
        bottom: p,
        left: d,
        right: c,
        width: O,
        height: E
      };
    }
    case "left":
    case "right": {
      var x = Math.min.apply(Math, r.map(function(f) {
        return f.left;
      })), g = Math.max.apply(Math, r.map(function(f) {
        return f.right;
      })), h = r.filter(function(f) {
        return e === "left" ? f.left === x : f.right === g;
      }), C = h[0].top, m = h[h.length - 1].bottom, T = x, D = g, n = D - T, y = m - C;
      return {
        top: C,
        bottom: m,
        left: T,
        right: D,
        width: n,
        height: y
      };
    }
    default:
      return t;
  }
}
var gi = {
  name: "sticky",
  defaultValue: !1,
  fn: function(t) {
    var r = t.reference, i = t.popper;
    function o() {
      return t.popperInstance ? t.popperInstance.state.elements.reference : r;
    }
    function a(d) {
      return t.props.sticky === !0 || t.props.sticky === d;
    }
    var s = null, u = null;
    function p() {
      var d = a("reference") ? o().getBoundingClientRect() : null, c = a("popper") ? i.getBoundingClientRect() : null;
      (d && Jt(s, d) || c && Jt(u, c)) && t.popperInstance && t.popperInstance.update(), s = d, u = c, t.state.isMounted && requestAnimationFrame(p);
    }
    return {
      onMount: function() {
        t.props.sticky && p();
      }
    };
  }
};
function Jt(e, t) {
  return e && t ? e.top !== t.top || e.right !== t.right || e.bottom !== t.bottom || e.left !== t.left : !0;
}
w.setDefaultProps({
  render: br
});
w.setDefaultProps({
  //@ts-ignore
  onShow: (e) => {
    if (!e.props.content)
      return !1;
  }
});
function hi(e, t = {}, r = { mount: !0 }) {
  const i = Mr(), o = he(), a = he({
    isEnabled: !1,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  });
  let s = null;
  const u = () => s || (s = document.createDocumentFragment(), s), p = (f) => {
    let v, A = Ee(f) ? f.value : f;
    if (Lr(A))
      i && (A.appContext = i.appContext), Bt(A, u()), v = () => u();
    else if (typeof A == "object") {
      let R = at(A);
      i && (R.appContext = i.appContext), Bt(R, u()), v = () => u();
    } else
      v = A;
    return v;
  }, d = (f) => {
    let v = {};
    return Ee(f) ? v = f.value || {} : Lt(f) ? v = { ...f } : v = { ...f }, v.content && (v.content = p(v.content)), v.triggerTarget && (v.triggerTarget = Ee(v.triggerTarget) ? v.triggerTarget.value : v.triggerTarget), (!v.plugins || !Array.isArray(v.plugins)) && (v.plugins = []), v.plugins = v.plugins.filter((A) => A.name !== "vueTippyReactiveState"), v.plugins.push({
      name: "vueTippyReactiveState",
      fn: () => ({
        onCreate() {
          a.value.isEnabled = !0;
        },
        onMount() {
          a.value.isMounted = !0;
        },
        onShow() {
          a.value.isMounted = !0, a.value.isVisible = !0;
        },
        onShown() {
          a.value.isShown = !0;
        },
        onHide() {
          a.value.isMounted = !1, a.value.isVisible = !1;
        },
        onHidden() {
          a.value.isShown = !1;
        },
        onUnmounted() {
          a.value.isMounted = !1;
        },
        onDestroy() {
          a.value.isDestroyed = !0;
        }
      })
    }), v;
  }, c = () => {
    o.value && o.value.setProps(d(t));
  }, O = () => {
    !o.value || !t.content || o.value.setContent(p(t.content));
  }, E = (f) => {
    var v;
    (v = o.value) === null || v === void 0 || v.setContent(p(f));
  }, x = (f) => {
    var v;
    (v = o.value) === null || v === void 0 || v.setProps(d(f));
  }, g = () => {
    o.value && (o.value.destroy(), o.value = void 0), s = null;
  }, h = () => {
    var f;
    (f = o.value) === null || f === void 0 || f.show();
  }, C = () => {
    var f;
    (f = o.value) === null || f === void 0 || f.hide();
  }, m = () => {
    var f;
    (f = o.value) === null || f === void 0 || f.disable(), a.value.isEnabled = !1;
  }, T = () => {
    var f;
    (f = o.value) === null || f === void 0 || f.enable(), a.value.isEnabled = !0;
  }, D = () => {
    var f;
    (f = o.value) === null || f === void 0 || f.unmount();
  }, n = () => {
    if (!e)
      return;
    let f = Ee(e) ? e.value : e;
    typeof f == "function" && (f = f()), f && (o.value = w(f, d(t)), f.$tippy = y);
  }, y = {
    tippy: o,
    refresh: c,
    refreshContent: O,
    setContent: E,
    setProps: x,
    destroy: g,
    hide: C,
    show: h,
    disable: m,
    enable: T,
    unmount: D,
    mount: n,
    state: a
  };
  return r.mount && (i ? (i.isMounted ? n() : xt(n), Rr(() => {
    g();
  })) : n()), Ee(t) || Lt(t) ? st(t, c, { immediate: !1 }) : Ee(t.content) && st(t.content, O, { immediate: !1 }), y;
}
function yi(e, t) {
  const r = he();
  return xt(() => {
    const o = (Array.isArray(e) ? e.map((a) => a.value) : typeof e == "function" ? e() : e.value).map((a) => a instanceof Element ? a._tippy : a).filter(Boolean);
    r.value = si(o, t ? { allowHTML: !0, ...t } : { allowHTML: !0 });
  }), {
    singleton: r
  };
}
const xi = Qt({
  props: {
    to: {
      type: [String, Function]
    },
    tag: {
      type: String,
      default: "span"
    },
    contentTag: {
      type: String,
      default: "span"
    },
    contentClass: {
      type: String,
      default: null
    },
    appendTo: { default: () => w.defaultProps.appendTo },
    aria: { default: () => w.defaultProps.aria },
    delay: { default: () => w.defaultProps.delay },
    duration: { default: () => w.defaultProps.duration },
    getReferenceClientRect: { default: () => w.defaultProps.getReferenceClientRect },
    hideOnClick: { type: [Boolean, String], default: () => w.defaultProps.hideOnClick },
    ignoreAttributes: { type: Boolean, default: () => w.defaultProps.ignoreAttributes },
    interactive: { type: Boolean, default: () => w.defaultProps.interactive },
    interactiveBorder: { default: () => w.defaultProps.interactiveBorder },
    interactiveDebounce: { default: () => w.defaultProps.interactiveDebounce },
    moveTransition: { default: () => w.defaultProps.moveTransition },
    offset: { default: () => w.defaultProps.offset },
    onAfterUpdate: { default: () => w.defaultProps.onAfterUpdate },
    onBeforeUpdate: { default: () => w.defaultProps.onBeforeUpdate },
    onCreate: { default: () => w.defaultProps.onCreate },
    onDestroy: { default: () => w.defaultProps.onDestroy },
    onHidden: { default: () => w.defaultProps.onHidden },
    onHide: { default: () => w.defaultProps.onHide },
    onMount: { default: () => w.defaultProps.onMount },
    onShow: { default: () => w.defaultProps.onShow },
    onShown: { default: () => w.defaultProps.onShown },
    onTrigger: { default: () => w.defaultProps.onTrigger },
    onUntrigger: { default: () => w.defaultProps.onUntrigger },
    onClickOutside: { default: () => w.defaultProps.onClickOutside },
    placement: { default: () => w.defaultProps.placement },
    plugins: { default: () => w.defaultProps.plugins },
    popperOptions: { default: () => w.defaultProps.popperOptions },
    render: { default: () => w.defaultProps.render },
    showOnCreate: { type: Boolean, default: () => w.defaultProps.showOnCreate },
    touch: { type: [Boolean, String, Array], default: () => w.defaultProps.touch },
    trigger: { default: () => w.defaultProps.trigger },
    triggerTarget: { default: () => w.defaultProps.triggerTarget },
    animateFill: { type: Boolean, default: () => w.defaultProps.animateFill },
    followCursor: { type: [Boolean, String], default: () => w.defaultProps.followCursor },
    inlinePositioning: { type: Boolean, default: () => w.defaultProps.inlinePositioning },
    sticky: { type: [Boolean, String], default: () => w.defaultProps.sticky },
    allowHTML: { type: Boolean, default: () => w.defaultProps.allowHTML },
    animation: { default: () => w.defaultProps.animation },
    arrow: { default: () => w.defaultProps.arrow },
    content: { default: () => w.defaultProps.content },
    inertia: { default: () => w.defaultProps.inertia },
    maxWidth: { default: () => w.defaultProps.maxWidth },
    role: { default: () => w.defaultProps.role },
    theme: { default: () => w.defaultProps.theme },
    zIndex: { default: () => w.defaultProps.zIndex }
  },
  emits: ["state"],
  setup(e, { slots: t, emit: r, expose: i }) {
    const o = he(), a = he(), s = he(!1), u = () => {
      let O = { ...e };
      for (const E of ["to", "tag", "contentTag", "contentClass"])
        O.hasOwnProperty(E) && delete O[E];
      return O;
    };
    let p = o;
    e.to && (typeof Element < "u" && e.to instanceof Element ? p = () => e.to : (typeof e.to == "string" || e.to instanceof String) && (p = () => document.querySelector(e.to)));
    const d = hi(p, u());
    xt(() => {
      s.value = !0, Ar(() => {
        t.content && d.setContent(() => a.value);
      });
    }), st(d.state, () => {
      r("state", Dr(d.state));
    }, { immediate: !0, deep: !0 }), st(() => e, () => {
      d.setProps(u()), t.content && d.setContent(() => a.value);
    });
    let c = Sr({
      elem: o,
      contentElem: a,
      mounted: s,
      ...d
    });
    return i(c), () => {
      const O = t.default ? t.default(c) : [];
      return at(e.tag, { ref: o, "data-v-tippy": "" }, t.content ? [
        O,
        at(e.contentTag, {
          ref: a,
          style: { display: s.value ? "inherit" : "none" },
          class: e.contentClass
        }, t.content(c))
      ] : O);
    };
  }
}), bi = [
  "a11y",
  "allowHTML",
  "arrow",
  "flip",
  "flipOnUpdate",
  "hideOnClick",
  "ignoreAttributes",
  "inertia",
  "interactive",
  "lazy",
  "multiple",
  "showOnInit",
  "touch",
  "touchHold"
];
let Ot = {};
Object.keys(w.defaultProps).forEach((e) => {
  bi.includes(e) ? Ot[e] = {
    type: Boolean,
    default: function() {
      return w.defaultProps[e];
    }
  } : Ot[e] = {
    default: function() {
      return w.defaultProps[e];
    }
  };
});
const Ci = Qt({
  props: Ot,
  setup(e) {
    const t = he([]), { singleton: r } = yi(t, e);
    return { instances: t, singleton: r };
  },
  mounted() {
    var e;
    const r = this.$el.parentElement.querySelectorAll("[data-v-tippy]");
    this.instances = Array.from(r).map((i) => i._tippy).filter(Boolean), (e = this.singleton) === null || e === void 0 || e.setInstances(this.instances);
  },
  render() {
    let e = this.$slots.default ? this.$slots.default() : [];
    return at(() => e);
  }
}), wi = w.setDefaultProps;
wi({
  ignoreAttributes: !0,
  plugins: [gi, vi, ci, ui]
});
export {
  Ci as T,
  xi as a,
  w as t
};
//# sourceMappingURL=vue-tippy.esm-browser-BFHHjfeY.mjs.map
